import { useEffect, useState } from 'react';
import { getSiteSettings } from '../config/firebase';

const defaults = {
  contactAddress: '#8 Janet  Samking  Drive, Reservation opposite Bo City Council',
  contactEmail: 'healthiersmileinitiative@gmail.com',
  contactPhones: '+232 78 036 464 / +232 78 656 579',
};

const Footer = () => {
  const [contact, setContact] = useState(defaults);

  useEffect(() => {
    getSiteSettings().then((s) => setContact({
      contactAddress: s.contactAddress || defaults.contactAddress,
      contactEmail: s.contactEmail || defaults.contactEmail,
      contactPhones: s.contactPhones || defaults.contactPhones,
    })).catch(() => {});
  }, []);

  return (
    <footer className="bg-teal-800 text-white">
      <div className="container mx-auto px-6 py-12 max-w-7xl">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold">Healthier Smile Initiatives</h3>
            <p className="mt-2 text-teal-200">Building Communities through Healthier Smiles</p>
          </div>
          <div>
            <h4 className="font-semibold text-lg">Quick Links</h4>
            <ul className="mt-2 space-y-1">
              <li><a href="#story" className="text-teal-200 hover:text-white">Our Story</a></li>
              <li><a href="#strategy" className="text-teal-200 hover:text-white">Our Strategy</a></li>
              <li><a href="#join-us" className="text-teal-200 hover:text-white">Get Involved</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-lg">Contact Us</h4>
            <ul className="mt-2 space-y-1 text-teal-200">
              <li>{contact.contactAddress}</li>
              <li>{contact.contactEmail}</li>
              <li>{contact.contactPhones}</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-teal-700 pt-6 text-center text-teal-300">
          <p>&copy; 2025 Healthier Smile Initiatives. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;